export default __webpack_public_path__ + "static/media/Confetti-Doodles.5d90b1f8.svg";